function initVendorListSlider(root) {
  const carousel = root?.querySelector?.('[data-vendor-list-slider]');
  if (!carousel || !window.jQuery || !jQuery.fn.slick) return;

  if (jQuery(carousel).hasClass('slick-initialized')) {
    jQuery(carousel).slick('unslick');
  }

  const gridDesktop = parseInt(carousel.dataset.gridDesktop || '3', 10);
  const gridMobile = parseInt(carousel.dataset.gridMobile || '1', 10);
  const mobileSlides = gridMobile === 2 ? 2 : 1;

  jQuery(carousel).slick({
    slidesToShow: gridDesktop,
    slidesToScroll: gridDesktop,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: `<button type="button" class="navigation__button custom_btn_div_prev navigation__button--prev" data-navigation-prev>
      <svg xmlns="http://www.w3.org/2000/svg" width="34.785" height="25.288" viewBox="0 0 34.785 25.288">
        <g transform="translate(32.902 14.512) rotate(135)">
          <path d="M22.077,36.669c-1.6,1.888-4.283-.284-5.728-1.25L8.156,29.938a3.121,3.121,0,0,1-1.1-1.03c-.7-1.314.656-2.74,1.818-3.671a41.939,41.939,0,0,0,6.783-6.849,14.657,14.657,0,0,1,3.65-3.8c1.223-.734,3.769-.963,3.125,1.264-.221.762-2.414,3.168-2.933,3.737-2.38,2.61-3.156,3.39-5.537,6L36.171,25a5.1,5.1,0,0,1,2.313.3,1.745,1.745,0,0,1,1.07,1.884c-.277,1.04-1.622,1.28-2.7,1.317-7.549.262-15.777.4-23.328.586,1.841,1.191,5.741,3.491,7.6,4.691.92.6,1.787,1.915.954,2.9Z" transform="translate(0 0)" fill="#1e1e1c" stroke="#fff" stroke-width="2"/>
        </g>
      </svg>
    </button>`,
    nextArrow: `<button type="button" class="navigation__button custom_btn_div_next navigation__button--next" data-navigation-next>
      <svg xmlns="http://www.w3.org/2000/svg" width="34.786" height="25.288" viewBox="0 0 34.786 25.288">
        <path d="M24.382,36.669c1.6,1.888,4.283-.284,5.728-1.25L38.3,29.938a3.121,3.121,0,0,0,1.1-1.03c.7-1.314-.656-2.74-1.818-3.671A41.939,41.939,0,0,1,30.8,18.388a14.657,14.657,0,0,0-3.65-3.8c-1.223-.734-3.769-.963-3.125,1.264.221.762,2.414,3.168,2.933,3.737,2.38,2.61,3.156,3.39,5.537,6L10.288,25a5.1,5.1,0,0,0-2.313.3,1.745,1.745,0,0,0-1.07,1.884c.277,1.04,1.622,1.28,2.7,1.317,7.549.262,15.777.4,23.328.586-1.841,1.191-5.741,3.491-7.6,4.691-.92.6-1.787,1.915-.954,2.9Z" transform="translate(-6.863 -14.075)" fill="#1e1e1c" stroke="#fff" stroke-width="2"/>
      </svg>
    </button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: mobileSlides,
          slidesToScroll: mobileSlides,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: Math.min(gridDesktop, 3),
          slidesToScroll: 2,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
}

function getVendorListSectionRoot(element) {
  return element.closest('.shopify-section');
}

function updateVendorListLayout(vendorList, slider) {
  const cards = slider.querySelectorAll('.product-card, .js-product-card, product-card');
  const count = cards.length;
  const gridDesktop = parseInt(vendorList.dataset.gridDesktop || '3', 10);
  const gridMobile = parseInt(vendorList.dataset.gridMobile || '1', 10);
  const navigation = vendorList.querySelector('.js-vendor-list-navigation');

  slider.classList.remove('grid-layou6t--align-center');

  if (navigation) {
    navigation.removeAttribute('items-overflow');
    navigation.removeAttribute('items-overflow-max');

    if (count > gridDesktop) {
      navigation.setAttribute('items-overflow', '');
    } else if (count > gridMobile) {
      navigation.setAttribute('items-overflow-max', 'phab');
    }
  }

  if (gridDesktop > count) {
    slider.classList.add('grid-layou6t--align-center');
  }
}

class VendorList extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url) return;

    if (this.hasAttribute('on-page-load')) {
      this._loadProducts();
      return;
    }

    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.unobserve(this);
          this._loadProducts();
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }

  _loadProducts() {
    if (this.dataset.loaded === 'true') return;

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const results = html.querySelector('[data-vendor-list-results]');
        const slider = this.querySelector('[data-vendor-list-slider]');

        if (!results || !slider) {
          this._hideSection();
          return;
        }

        slider.innerHTML = results.innerHTML;

        const excludeId = this.dataset.excludeProductId;
        if (excludeId) {
          const currentCard = slider.querySelector(
            `.product-card[data-product-id="${excludeId}"], .js-product-card[data-product-id="${excludeId}"], product-card[data-product-id="${excludeId}"]`,
          );
          currentCard?.remove();
        }

        const cards = slider.querySelectorAll('.product-card, .js-product-card, product-card');
        if (cards.length === 0) {
          this._hideSection();
          return;
        }

        this.dataset.loaded = 'true';
        slider.setAttribute('data-slider_custom', '');
        updateVendorListLayout(this, slider);
        initVendorListSlider(getVendorListSectionRoot(this));
      })
      .catch((error) => {
        console.error(error);
        this._hideSection();
      });
  }

  _hideSection() {
    getVendorListSectionRoot(this)?.remove();
  }
}

customElements.define('vendor-list', VendorList);

document.addEventListener('shopify:section:load', (event) => {
  const vendorList = event.target.querySelector('vendor-list');
  if (vendorList?.dataset.loaded === 'true') {
    const slider = vendorList.querySelector('[data-vendor-list-slider]');
    if (slider) {
      updateVendorListLayout(vendorList, slider);
      initVendorListSlider(event.target);
    }
  }
});
